module.exports = __webpack_public_path__ + "img/bx-window-success.59ea86b9.png";